var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarWeek(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 40,
    viewBox: "0 0 35 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1588_15497)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 36.25C0 38.3203 1.67969 40 3.75 40H31.25C33.3203 40 35 38.3203 35 36.25V15H0V36.25ZM5 21.25C5 20.5625 5.5625 20 6.25 20H28.75C29.4375 20 30 20.5625 30 21.25V26.25C30 26.9375 29.4375 27.5 28.75 27.5H6.25C5.5625 27.5 5 26.9375 5 26.25V21.25ZM31.25 5H27.5V1.25C27.5 0.5625 26.9375 0 26.25 0H23.75C23.0625 0 22.5 0.5625 22.5 1.25V5H12.5V1.25C12.5 0.5625 11.9375 0 11.25 0H8.75C8.0625 0 7.5 0.5625 7.5 1.25V5H3.75C1.67969 5 0 6.67969 0 8.75V12.5H35V8.75C35 6.67969 33.3203 5 31.25 5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1588_15497"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarWeek);
export default __webpack_public_path__ + "static/media/calendarWeek.0a925750a59a74e518a6a76e5711392d.svg";
export { ForwardRef as ReactComponent };